import IgnisIcon from '../icons/IgnisIcon';

interface ModuleBadgeProps {
  label: string;
  module?: string;
  dark?: boolean;
}

export default function ModuleBadge({ label, module = 'IGNIS', dark = false }: ModuleBadgeProps) {
  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-[1000]">
      <div
        className={`rounded-full px-4 py-2 flex items-center gap-2 backdrop-blur ${
          dark ? 'bg-ink-900/85 border border-ink-700 shadow-2xl' : 'bg-white/90 shadow-warm'
        }`}
      >
        <IgnisIcon className={`w-4 h-4 ${dark ? 'text-ember' : 'text-tutela-terracotta'}`} />
        <span className={`text-sm font-medium ${dark ? 'text-mist' : 'text-tutela-charcoal'}`}>{module}</span>
        <span className={dark ? 'text-mist-faint' : 'text-tutela-slate'}>|</span>
        <span className={`text-sm ${dark ? 'text-mist-muted' : 'text-tutela-slate'}`}>{label}</span>
      </div>
    </div>
  );
}
